import { useEffect, useMemo, useState } from "react";
import {
  useGetInterviewTypeData,
  useInitiatePayment,
} from "../Hooks/AssesmentHooks";
import aidynamicimage from "././../Assets/Icons/ai_dynamic.jpg";
import bigfiveimage from "././../Assets/Icons/bigfive_personality.jpg";
import jwtEncode from "jwt-encode";
import HireHubHeader from "./HireHubHeader";
import { IoArrowBackSharp } from "react-icons/io5";
import { useLocation, useNavigate } from "react-router-dom";
import { interview_types } from "../Utils/constants";

const HireHubTalent = () => {
  const user_id = localStorage.getItem("candidate");
    const interview_type = localStorage.getItem("interview_type");
  const [isOpen, setIsOpen] = useState(false);
  const [openedData, setOpenedData] = useState({});
  // const location = useLocation();
  // const type = new URLSearchParams(location?.search).get("type");
  const navigate = useNavigate();

  const {
    data: interviewTypesData,
    status: interviewTypesDataStatus,
    refetch: refetchinterviewTypeData,
    isLoading: loadingInterviewTypeData,
    isFetching: fetchingInterviewTypeData,
  } = useGetInterviewTypeData({
    params: {},
    enabled: !!user_id,
  });

  const { mutate: initiatePayment, isLoading: isInitialPaymentLoading } =
    useInitiatePayment({
      handleOnSuccess: (data) => {
        console.log(data, "dddaaattaaa");
        window.location.href = data?.redirectUrl;
      },
      onError: () => {
        // messageApi.open({
        //   type: 'error',
        //   content: DEFAULT_ERROR_MESSAGE,
        // });
      },
    });

  // Proceed to payment success modal
  const handleProceed = async () => {
    const data = {
      company_interview_id: openedData?.company_interview_id,
    };
    await initiatePayment({ data });
    // setIsOpen(false);
    // setTimeout(() => setIsPaymentModal(true), 200);
  };

  const type_data = useMemo(()=> {
  console.log("interviewTypesDatainterviewTypesData",interview_type);

    return interviewTypesData?.interviews_payment_details?.filter((item=> item?.interview_type === interview_type))
  },[interview_type, interviewTypesData])

  // useEffect(()=> {
  //   if(type_data?.length > 0){
  //     localStorage.removeItem("interview_type");
  //   }
  // },[type_data])
  
  console.log(type_data,"type_datatype_data",interview_type);


  return (
    <>
      <div className="w-full flex items-center justify-between px-52">
        <p
          className="flex items-center gap-2 cursor-pointer font-semibold mr-2"
          onClick={() => navigate(-1)}
        >
          <IoArrowBackSharp />
          Back
        </p>
        <HireHubHeader />
      </div>

      <div className="w-full mt-6">
        <div className=" mx-auto flex flex-wrap  justify-center gap-8 full md:w-[80%]">
          {type_data?.map((item) => (
            <div className="shadow-md hover:shadow-lg rounded-sm overflow-hidden bg-white w-full sm:w-[90%] md:w-[45%] p-3">
              <img
                src={
                  item?.interview_type === interview_types?.assessment
                    ? aidynamicimage
                    : bigfiveimage
                }
                alt="AI Dynamic Interview"
                className="w-full h-80 object-cover"
              />
              <div className="p-4">
                <h3 className="text-lg font-semibold mb-2">{item?.label}</h3>
                <p className="text-sm text-gray-600 mb-4">
                  {item?.description}
                </p>
                <div className="flex justify-between items-center">
                  {item?.status === "UNPAID" ||
                  (item?.status === "PAID" && item?.attended_status) ? (
                    <button
                      className="bg-[#0071DC] p-2 px-8 text-white font-bold rounded-md"
                      onClick={() => {
                        const token = jwtEncode(item, "");
                        console.log(token, "token>>?");

                        window.open(
                          `https://hirehub.ipecsolutions.com/payment-checkout?token=${token}`,
                          "_blank",
                        );
                      }}
                    >
                      Pay Now
                    </button>
                  ) : (
                    <button
                      className="bg-[#1229fa] p-2 px-8 text-white font-bold rounded-md"
                      onClick={() => window.open(item?.link, "_blank")}
                    >
                      Start Interview
                    </button>
                  )}

                  <span className="font-bold text-xl">₹{item?.fee}</span>
                </div>
              </div>
            </div>
          ))}

          {isOpen && (
            <div
              className="fixed inset-0 flex items-center justify-center bg-black/50 z-50 px-4 sm:px-6"
              onClick={() => setIsOpen(false)}
            >
              <div
                className="bg-white w-full max-w-lg sm:max-w-xl rounded-2xl shadow-2xl p-6 sm:p-10 md:p-16 relative overflow-y-auto max-h-[90vh]"
                onClick={(e) => e.stopPropagation()}
              >
                <h2 className="text-lg sm:text-xl font-semibold text-gray-800 mb-6 text-center sm:text-left">
                  Review & Confirm
                </h2>

                <div className="flex flex-col sm:flex-row items-center sm:items-start sm:gap-6 border p-4 rounded-lg bg-gray-50 mb-6">
                  <img
                    src={
                      openedData?.interview_type === "Master Your Interview"
                        ? aidynamicimage
                        : bigfiveimage
                    }
                    alt="Product"
                    className="w-24 h-24 object-cover rounded-md mb-4 sm:mb-0"
                  />
                  <div className="text-center sm:text-left">
                    <p className="font-medium text-gray-800 text-base">
                      {openedData?.interview_type}
                    </p>
                    <p className="text-[#0071DC] font-semibold text-lg">
                      ₹{openedData?.fee}
                    </p>
                  </div>
                </div>

                <div className="space-y-3 text-sm sm:text-base text-black mb-6">
                  <p className="flex justify-between">
                    <span className="font-medium text-gray-700 w-24">Date</span>
                    <span>{openedData?.date}</span>
                  </p>
                  <p className="flex justify-between">
                    <span className="font-medium text-gray-700 w-24">Name</span>
                    <span>{openedData?.candidate_name}</span>
                  </p>
                  <p className="flex justify-between">
                    <span className="font-medium text-gray-700 w-24">
                      Email
                    </span>
                    <span className="truncate max-w-[150px] sm:max-w-none text-right">
                      {openedData?.email}
                    </span>
                  </p>
                </div>

                <div className="flex justify-between items-center border-t pt-4 mb-6">
                  <span className="font-bold text-black text-base sm:text-lg">
                    Total Amount
                  </span>
                  <span className="font-bold text-lg text-[#0071DC]">
                    ₹{openedData?.fee}
                  </span>
                </div>

                <div className="flex flex-col sm:flex-row justify-end gap-3 sm:gap-4 mt-10 sm:mt-14">
                  <button
                    onClick={() => setIsOpen(false)}
                    className="w-full sm:w-auto px-5 py-2.5 border border-[#0071DC] rounded-md text-[#0071DC] hover:bg-gray-100 transition"
                  >
                    Cancel Payment
                  </button>
                  <button
                    className="w-full sm:w-auto px-5 py-2.5 bg-[#0071DC] text-white rounded-md font-medium hover:bg-[#005bb5] transition"
                    onClick={() => handleProceed()}
                    disabled={isInitialPaymentLoading}
                  >
                    Proceed to Checkout
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default HireHubTalent;
